// extracted by mini-css-extract-plugin
module.exports = {"customerModal":"CustommerLocation_customerModal__1SP5k"};